import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import Alpine from "alpinejs";

import { registerCarousel } from "./alpine/carousel";
import cmsStore from "./alpine/cms";
import { registerLiquidGradient } from "./alpine/liquid-gradient";
import { initMagneticBtns, registerMagneticBtn } from "./alpine/magnetic-btn";
import { registerMotionStore } from "./alpine/motion-store";
import { registerPreEventCatalogue } from "./alpine/pre-event-catalogue";
import { registerTypingText } from "./alpine/typing-text";
import { getMotionTier, initMotion } from "./motion";

initMotion();

if (getMotionTier() !== "reduce") {
	for (const el of document.querySelectorAll("[data-collapse-panel]")) {
		el.setAttribute("x-collapse", "");
	}
}

document.addEventListener("alpine:init", () => {
	registerMotionStore();
	registerPreEventCatalogue();
	registerLiquidGradient();
	registerMagneticBtn();
	registerTypingText();
	registerCarousel();
	initMagneticBtns();
});

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.store("cms", cmsStore);
window.Alpine = Alpine;
Alpine.start();

declare global {
	interface Window {
		Alpine: typeof Alpine;
	}
}
